import ScoreCricketNew from "./ScoreCricketNew";
export default ScoreCricketNew;
